import { createSingularAsyncApi } from "../../partials/async"
import { createToast } from "@/modules/toast-message"
import { computed } from "vue"

export default function createFACTypeData(){
    const api = createSingularAsyncApi(
        'bt_get_fac_type_by_slug',
        'GET',
        {
            responseKey : 'fac_type',
            callbacks   : {
                onError    : (data, original, errors) => {    
                    if(data.code === 404){
                        createToast("This FAC type couldn't be found", "error")
                        errors.value.display_error = ['FAC Type couldn\'t be found']
                        errors.value.fac_type      = ['Error: FAC Type doesn\'t exist'] //So we can hide the search
                    } else {
                        createToast("Couldn't load FAC type, please try again", "error")
                        errors.value.display_error = ['Couldn\'t load FAC type, please reload the page']
                    }
                }
            }
        }
    )

    const hasSearchDisplayLocation = (field, displayLocation) => {
        field.fac_search_display_locations.some(
            searchDisplayLocation => searchDisplayLocation.fac_search_display_location.value === displayLocation
        )
    }

    return {
        ...api,

        headerSearchFields: computed(
            () => (api.details.value?.fields ?? []).filter(
                field => field?.fac_search_filter_display_location?.value === 'header'
            )
        ),

        sidebarSearchFields: computed(
            () => (api.details.value?.fields ?? []).filter(
                field => field?.fac_search_filter_display_location !== null
            )
        ),

        fields: computed(() => (api.details.value?.fields ?? []).reduce(
            (fields, field) => ({
                ...fields,
                [field.id]: field
            }),
            {}
        )),

        fieldsForDisplayLocations: computed(
            () => (api.details.value?.fields ?? []).reduce(
                (groups, field) => {              
                    (field?.fac_search_display_locations ?? []).forEach(
                        (displayLocation) => {
                            if(groups[displayLocation.fac_search_display_location.value] === undefined){
                                groups[displayLocation.fac_search_display_location.value] = {[field.id]: field}
                            } else {
                                groups[displayLocation.fac_search_display_location.value][field.id] = field
                            }
                        }
                    )

                    return groups
                },
                {}
            )
        )

        // headerSearchFields: computed(() => {
        //     (api.details.value?.fields?.value ?? []).filter(
        //         field => hasSearchDisplayLocation('')
        //     )
        // })
    }
}